import { createPortal } from 'react-dom';
import PackDetailContent from './PackDetailContent.jsx';
import './RecipePacks.css';

/**
 * PackDetailModal — desktop modal overlay for pack detail.
 * Width 540px, centered, backdrop click closes.
 *
 * PROTECTED presentation (DESIGN_SYSTEM.md → Protected: pack detail overlay).
 * Do not replace with DS form Modal + ModalHeader/Footer for cohesion-only reasons.
 * Shared body: PackDetailContent. Mobile counterpart: PackDetailSheet.
 */
export default function PackDetailModal({ pack, added, onClose, onAdd }) {
  if (!pack) return null;
  return createPortal(
    <div className="rp-modal-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-label={`${pack.name} pack detail`}>
      <div className="rp-modal-content" onClick={e => e.stopPropagation()}>
        <PackDetailContent pack={pack} added={added} onClose={onClose} onAdd={onAdd} compact={false} />
      </div>
    </div>,
    document.body
  );
}
